import axios from "../../axios-config";

export const quoteCampaignFee = async ({ adAccountId, budget, budgetType }) => {
    const res = await axios.post("/campaign/v1/quote-campaign-fee", {
        adAccountId,
        budget,
        budgetType,
    });
    return {
        feeRequired: res.data?.feeRequired === true,
        quote: res.data?.data || null,
    };
};

export const initCampaignFeePayment = async ({ quoteId }) => {
    const res = await axios.post("/campaign/v1/init-campaign-fee-payment", {
        quoteId,
    });
    return res.data;
};
